import React from "react";
import { Rows2, Rows3 } from "lucide-react";
import useSheetDensity from "../hooks/useSheetDensity";

/**
 * The roomy/compact row toggle, in one place.
 *
 * Mounted in four places, all on the "sheet" scope (see
 * hooks/useSheetDensity.js): SheetFooter's bottom row, which covers the six
 * sheets that render it, plus the stats bands of Inventory, Committed and
 * Credit, which render their own footer instead and so each mount it by hand.
 *
 * THE "grid" SCOPE HAS NO TOGGLE AT PRESENT. It belonged to the vehicle modal's
 * three table tabs, and RecordList dropped the control when it absorbed them —
 * see its header for the reasoning. The scope still exists and CarsNav still
 * mounts the hook, so those tables read `data-grid-density` and get their 32px
 * default; the `html[data-grid-density="comfortable"]` branch in carstyles.css is
 * consequently unreachable until something offers the toggle again.
 *
 * THE ID IS OPT-IN. The Sales tour (useTabJoyride.js) spotlights
 * #sheet-density-toggle, so SheetFooter passes that id and must keep passing it.
 * The three sheet bands pass ids of their own rather than reusing it: two
 * elements sharing one id is how a tour ends up spotlighting the wrong screen.
 *
 * The label is a prop for a related reason: in a sheet footer this sits in a
 * labelled row of controls, but standing alone in a button bar a bare icon has
 * nothing next to it to explain what it does.
 */
export default function DensityToggle({ id, scope = "sheet", showLabel = false }) {
    const [density, toggleDensity] = useSheetDensity(scope);
    const isCompact = density === "compact";

    return (
        <button
            id={id}
            type="button"
            className="btn-t btn-t-secondary sheet-density-btn"
            onClick={toggleDensity}
            aria-pressed={isCompact}
            title={isCompact ? "Switch to roomier rows" : "Switch to compact rows"}
        >
            {isCompact ? <Rows3 size={16} /> : <Rows2 size={16} />}
            {showLabel && <span>{isCompact ? "Compact" : "Roomy"}</span>}
        </button>
    );
}
